import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@mui/material';
import React from 'react';

export default function BuildingActionsCell({ row, onView, onEdit, onDelete }) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleMenuItemClick = (option) => {
    setOpen(false);
    if (option === 'view') {
      onView(row);
    }
    if (option === 'edit') {
      onEdit(row);
    }
    if (option === 'delete') {
      onDelete(row);
    }
  };

  return (
    <>
      <ButtonGroup
        variant="outlined"
        size="small"
        ref={anchorRef}
        aria-label="split button"
        sx={{
          '& .MuiButtonGroup-grouped:not(:last-of-type)': {
            borderRight: 'none',
          },
        }}
      >
        <Button
          size="small"
          onClick={() => handleMenuItemClick('view')}
          sx={{
            width: 75,
            borderColor: 'divider',
            ':hover': { borderColor: 'divider' },
          }}
        >
          View
        </Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
          sx={{
            borderColor: 'divider',
            ':hover': { borderColor: 'divider' },
          }}
        >
          <ArrowDropDownIcon fontSize="small" />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        modifiers={[
          {
            name: 'flip',
            options: { fallbackPlacements: ['top-start', 'bottom-start'] },
          },
          {
            name: 'preventOverflow',
            options: { altBoundary: true, rootBoundary: 'document' },
          },
        ]}
        style={{ zIndex: 1301 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              zIndex: 21302,
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="split-button-menu"
                  autoFocusItem
                  dense
                  sx={{ p: 1 }}
                >
                  <MenuItem
                    onClick={() => handleMenuItemClick('edit')}
                    sx={{
                      py: '6px',
                      px: '12px',
                      borderRadius: '5px',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <EditRoundedIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" fontWeight="medium">
                        Edit
                      </Typography>
                    </Box>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
